export const FETCHING = "FETCHING";
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const SORT = "SORT";
export const LOGOUT = "LOGOUT";
export const UPDATE_DATA_FIELD = "UPDATE_DATA_FIELD";
export const SET_DATA_FIELD = "SET_DATA_FIELD";
export const ADD_REFUND_TX = "ADD_REFUND_TX";
